'use client';

import { motion } from "framer-motion";

interface PageHeroProps {
  title: string;
  description: string;
  accentWord?: string;
  restOfTitle?: string;
  backgroundImage?: string;
}

export function PageHero({ title, description, accentWord, restOfTitle, backgroundImage }: PageHeroProps) {
  return (
    <section 
      className="relative py-32 md:py-40 overflow-hidden"
      style={{ backgroundColor: 'rgb(245,245,247)' }}
      aria-label="Page hero section"
      role="banner"
    >
      {backgroundImage && (
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
          aria-hidden="true"
        />
      )}

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative mx-auto max-w-[110rem] px-4 sm:px-6 lg:px-10"
      >
        <div className="max-w-2xl">
          <h1 className="text-5xl md:text-6xl font-bold mb-8 leading-tight uppercase" style={{ color: 'rgb(29,29,31)', fontFamily: '"Universal Sans Display", -apple-system, Arial, sans-serif', letterSpacing: '0.025em' }}>
            {accentWord ? (
              <>
                {restOfTitle}{" "}
                <span className="text-[#171A20]" aria-label={accentWord}>{accentWord}</span>
              </>
            ) : (
              title
            )}
          </h1>
          <p 
            className="text-lg md:text-xl leading-relaxed"
            style={{ color: 'rgba(0,0,0,0.88)' }}
            role="doc-subtitle"
          >
            {description}
          </p>
        </div>
      </motion.div>
    </section>
  );
} 